import PartnerSettingsStore from './PartnerSettings.store';

export const partnerSettingsStore = new PartnerSettingsStore();

export * from './interfaces';
